import { Pipe, PipeTransform } from '@angular/core';
import { ExamDifficulty } from '../../models/enums/exam.enums';

@Pipe({
  name: 'examDifficulty',
})
export class ExamDifficultyPipe implements PipeTransform {
  transform(difficulty: ExamDifficulty): string {
    switch (difficulty) {
      case ExamDifficulty.EASY:
        return $localize`Facile`;
      case ExamDifficulty.MEDIUM:
        return $localize`Modérée`;
      case ExamDifficulty.DIFFICULT:
        return $localize`Difficile`;
      default:
        return '';
    }
  }
}
